export default defineNuxtRouteMiddleware((to) => {
  const decodedUrl = decodeURIComponent(to.path);

  if (to.query.decoded) {
    return;
  }

  if (to.path !== decodedUrl) {
    return navigateTo({ path: decodedUrl, query: { ...to.query, decoded: 'true' } });
  }
});
